import { Box, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import SearchComponent from 'UiKit/search';
import ButtonSolid from 'UiKit/button/buttonSolid';
import FilterSelect from 'UiKit/filter-select';
import { PlusIcon } from 'Asset/icon';
import useGetBrand from 'Domain/brand/useGetBrand';
import useGetAccountType from 'Domain/live-account/useGetAccountType';
import { getMenuPermissions } from 'Helper/getMenuPermissions';
import { Condition } from 'Component/others';

import { useLiveAccountState } from 'View/live-account/state';

import styles from './styles.module.css';
import useGetEcommerce from 'Domain/ecommerce/useGetEcommerce';

const Filter = () => {
  const { t } = useTranslation('live-account');
  const { updateState, updateFilterState, filterState } = useLiveAccountState();
  const accessPermission = getMenuPermissions('master-data', 'account-livestream');

  const { data: platformOptions, isLoading: isLoadingPlatform } = useGetEcommerce({ enabled: true });
  const { data: brandOptions, isLoading: isLoadingBrand } = useGetBrand({ enabled: true });
  const { data: accountTypeOptions, isLoading: isLoadingAccountType } = useGetAccountType({ enabled: true });

  const onChangeFilter = (newFilter) => updateFilterState({ ...newFilter, page: 1 });

  return (
    <Box className={styles['filter__wrapper']}>
      <Flex className={styles['filter__container']}>
        <Flex className={styles['filter-item__container']}>
          <SearchComponent maxWidth="337px" onSearch={(value) => onChangeFilter({ search: value })} debounceTime={300} />

          <Box className={styles['filter__item']}>
            <FilterSelect
              isLoading={isLoadingBrand}
              placeholder={t('filterBrandPlaceholder')}
              value={filterState?.brand}
              clearable={true}
              width="128px"
              options={brandOptions}
              counterLabel={t('filterBrandCounter')}
              onChange={(value) => onChangeFilter({ brand: value })}
              isMulti
            />
          </Box>

          <Box className={styles['filter__item']}>
            <FilterSelect
              isLoading={isLoadingPlatform}
              placeholder={t('filterPlatformPlaceholder')}
              value={filterState?.platform}
              counterLabel={t('filterPlatformCounter')}
              clearable={true}
              width="145px"
              onChange={(value) => onChangeFilter({ platform: value })}
              isMulti
              options={platformOptions}
            />
          </Box>

          <Box className={styles['filter__item']}>
            <FilterSelect
              isLoading={isLoadingAccountType}
              placeholder={t('filterAccountTypePlaceholder')}
              value={filterState?.accountType}
              counterLabel={t('filterAccountTypeCounter')}
              clearable={true}
              onChange={(value) => onChangeFilter({ accountType: value })}
              width="171px"
              isMulti
              options={accountTypeOptions}
            />
          </Box>
        </Flex>

        <Condition statement={accessPermission?.isCanCreate}>
          <ButtonSolid
            type="button"
            className={styles['create__button']}
            leftIcon={<PlusIcon width="12px" height="12px" mt="2px" color="var(--color-semantic-white)" />}
            onClick={() => updateState({ isOpenFormUpsert: true })}
            data-testid="live-account__button-create"
          >
            {t('createButton')}
          </ButtonSolid>
        </Condition>
      </Flex>
    </Box>
  );
};

export default Filter;